module.exports = __webpack_public_path__ + "static/media/MOBI.f0430cef.svg";